/**
 * GeChiUI dependencies
 */
import { SVG, Path } from '@gechiui/primitives';

const paragraph = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M18.3 4H9.9v-.1l-.9.2c-2.3.4-4 2.4-4 4.8s1.7 4.4 4 4.8l.7.1V20h1.5V5.5h2.9V20h1.5V5.5h2.7V4z" />
	</SVG>
);

export default paragraph;
